import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";

export const Clock: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faClock} {...props} />
);
